import { Download, Edit } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import { tableConfig } from "./config/tableConfig";
import TitleContainer from "./utilsTable/titleWithFetchData";

const FilesTable = ({
  data,
  loading,
  fetchData,
  handleEdit,
  handleDownload,
}) => {
  const columns = [
    {
      header: "Descripción",
      accessorKey: "descripcion",
      Cell: ({ row }) => row.original.descripcion,
    },
    {
      header: "Acciones",
      accessorKey: "acciones",
      Cell: ({ row }) => (
        <div>
          <Tooltip title="Editar Archivo">
            <IconButton
              color="inherit"
              onClick={() => handleEdit(row.original)}>
              <Edit />
            </IconButton>
          </Tooltip>
          <Tooltip title="Descargar Archivo">
            <IconButton
              color="inherit"
              onClick={() => handleDownload(row.original)}>
              <Download />
            </IconButton>
          </Tooltip>
        </div>
      ),
      enableColumnFilter: false,
      enableColumnActions: false,
    },
  ];

  return (
    <div>
      <MaterialReactTable
        {...tableConfig}
        columns={columns}
        data={data}
        state={{ isLoading: loading }}
        renderTopToolbarCustomActions={() => (
          <TitleContainer title="Archivos Disponibles" fetchData={fetchData} />
        )}
      />
    </div>
  );
};

export default FilesTable;
